import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo_top.png'


const _hoisted_1 = { class: "HomeView" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "HomeView-Logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("チュートリアル")

import { reactive } from "vue";
import HelloVisitors from "@/components/HelloVisitors.vue";
import UITitle from "../components/ui/UITitle.vue";
import UIButton from "../components/ui/UIButton.vue";
import Modal from "@/components/Modal.vue";
// export default defineComponent({
//   name: "HomeView",
//   components: {
//     HelloWorld,
//   },
// });

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// import { defineComponent } from "vue";
// import { Ref } from 'vue';
const state = reactive({
	isVisible: false,
});
const title = "筋トレメニュージェネレーター";
const text = "筋トレのメニューを自動生成します";

const openModal = () => {
	state.isVisible = true;
};

const closeModal = () => {
	state.isVisible = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Modal, {
      isVisible: _unref(state).isVisible,
      onOnClickClose: closeModal
    }, null, 8, ["isVisible"]),
    _createVNode(UITitle, {
      title: title,
      titleType: "normal"
    }),
    _hoisted_2,
    _createVNode(HelloVisitors, { text: text }),
    _createVNode(UIButton, {
      onClick: openModal,
      class: "HomeView-Button",
      size: "large"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ]))
}
}

})